import { useTranslate } from '@refinedev/core';
import { Typography } from 'antd';
import type {
  CollectionSortRuleIn,
  CollectionSortRuleOut,
} from '@/api/generated/schemas';
import { useSortFields } from './useSortFields';

const { Text } = Typography;

interface Props {
  sorting?: (CollectionSortRuleOut | CollectionSortRuleIn)[] | null;
}

/**
 * Read-only render of a collection's effective sort order.
 *
 * Used both in show views and in the series/ranking forms, where the order is
 * built into the kind and cannot be edited — the editor still needs to see it.
 */
export const CollectionSortingShow = ({ sorting }: Props) => {
  const t = useTranslate();
  const { labels } = useSortFields();

  const rules = (sorting ?? []).filter((rule) => rule?.field);

  if (!rules.length) {
    return <Text>-</Text>;
  }

  return (
    <Text>
      {rules
        .map(
          (rule) =>
            `${labels[rule.field] ?? rule.field} · ${t(
              `base.collection.direction.${rule.direction}`
            )}`
        )
        .join(' → ')}
    </Text>
  );
};
